import { Check, Loader } from "lucide-react";

interface SaveIndicatorProps {
  /** True while a save request is in flight. */
  isSaving: boolean;
  /** True while there are unsaved edits pending a save. */
  isDirty: boolean;
}

/**
 * Subtle autosave state indicator for the document tab header. Shows a spinner
 * while saving, a pending label while dirty, and "Saved" when clean - the label
 * never text-swaps into a verb form.
 * @param isSaving - True while a save request is in flight
 * @param isDirty - True while there are unsaved edits pending a save
 */
export function SaveIndicator({ isSaving, isDirty }: SaveIndicatorProps) {
  if (isSaving) {
    return (
      <span className="flex items-center gap-1.5 text-xs text-muted-foreground">
        <Loader className="size-3.5 animate-spin" /> Saving
      </span>
    );
  }
  if (isDirty) {
    return (
      <span className="flex items-center gap-1.5 text-xs text-muted-foreground">
        <span className="size-1.5 rounded-full bg-muted-foreground/60" />
        Unsaved changes
      </span>
    );
  }
  return (
    <span className="flex items-center gap-1.5 text-xs text-muted-foreground">
      <Check className="size-3.5" /> Saved
    </span>
  );
}
